import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase, ref } from "firebase/database";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// "The content of the Firebase config file or object is considered public, including the app's
// platform-specific ID (Apple bundle ID or Android package name) and the Firebase project-specifi
// values, like the API Key, project ID, Realtime Database URL, and Cloud Storage bucket name.
// Given this, use Firebase Security Rules to protect your data and files in Realtime Database,
// Cloud Firestore, and Cloud Storage."
// https://firebase.google.com/docs/projects/learn-more#config-files-objects
const firebaseConfig = {
  apiKey: "AIzaSyBZPlD91BA3N5uYXitpLzZehJn3et9Gx9Q", // this is ok, see comment above
  authDomain: "directory-f635f.firebaseapp.com",
  databaseURL: "https://directory-f635f-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "directory-f635f",
  storageBucket: "directory-f635f.appspot.com",
  messagingSenderId: "884502450186",
  appId: "1:884502450186:web:78435251b03172abb64ff3",
  measurementId: "G-HLZ72F3MQZ"
};

const app = initializeApp(firebaseConfig);

// Initialize App Check FIRST, before any other Firebase services,
// so all service requests automatically include App Check tokens
export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider('6LeDxdkpAAAAAMo9d-J1VAuSdIWDkCpT-hwyoeeY'),  // site key is not sensitive
  isTokenAutoRefreshEnabled: true
});

const analytics = getAnalytics(app);
export const database = getDatabase(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const functions = getFunctions(app, 'europe-west1');
